export function removeEmojisFromTagName(stringer = '') {
  const emojiRegex1 = /\p{Emoji}/u;
  const emojiRegex2 =
    /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
  const tagClean1: string = stringer?.replace(emojiRegex2, '');
  const isEmoji = emojiRegex1.test(tagClean1?.[0]);
  return isEmoji ? tagClean1?.substring(1)?.trim() : tagClean1?.trim();
}
